import React, { useEffect } from 'react';
import CircularProgress from 'material-ui/CircularProgress';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getFlagCompliance } from 'actions/flagCompliance';
import styles from 'styles';
import FlagComplianceTable from './FlagComplianceTable';

function FlagCompliance({ getFlagCompliance, isLoaded }) {
    useEffect(() => {
        getFlagCompliance();
    }, []);

    return (
        <div className='table-page'>
            <CircularProgress
                className={!isLoaded ? '' : 'hidden'}
                style={styles.circularProgress}
            />

            <div className={isLoaded ? '' : 'hidden'}>
                <div className='container'>
                    <h2>Flag compliance</h2>
                    <FlagComplianceTable />
                </div>
            </div>
        </div>
    );
}

export default connect(
    () => { 
        return {
            isLoaded: true,
        };
    },
    dispatch => bindActionCreators(
        {
            getFlagCompliance,
        },
        dispatch,
    ),
)(FlagCompliance);



// WEBPACK FOOTER //
// ./app/components/FlagCompliance/FlagCompliance.jsx